<template>
  <div>
    <el-table :data="list" @selection-change="onSelectionChange" height="65vh">
      <el-table-column
        type="selection"
        width="55"
        align="center"
      ></el-table-column>
      <el-table-column label="采收批次号" prop="batchNumber" width="160">
      </el-table-column>
      <el-table-column label="采收日期" width="120">
        <template slot-scope="scope">{{
          formatDate(scope.row.harvestDate)
        }}</template>
      </el-table-column>

      <el-table-column prop="plantingBase" label="基地名称"></el-table-column>
      <el-table-column prop="greenhouseName" label="大棚编号"></el-table-column>
      <el-table-column prop="varietyName" label="产品名称"></el-table-column>

      <el-table-column label="重量合计 (kg)" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.sumWeight }}</template>
      </el-table-column>

      <el-table-column
        prop="harvestManager"
        label="采收负责人"
      ></el-table-column>

      <el-table-column label="更新时间" >
        <template slot-scope="scope">{{ scope.row.updateTime }}</template>
      </el-table-column>

      <el-table-column label="状态" width="100">
        <template slot-scope="scope">{{
          mapStatus(scope.row.status)
        }}</template>
      </el-table-column>

      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="$emit('view', scope.row)"
            >查看</el-button
          >
          <el-button
            v-if="canEdit(scope.row.status)"
            type="text"
            size="small"
            @click="$emit('edit', scope.row)"
            style="margin-left: 8px"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrapper" style="margin-top: 12px">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="page.page"
        :page-size="page.pageSize"
        :page-sizes="[10, 20, 50]"
        :total="page.totalCount"
        @size-change="$emit('size-change', $event)"
        @current-change="$emit('current-change', $event)"
      />
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "OrderTable",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    page: {
      type: Object,
      default: () => ({ page: 1, pageSize: 10, totalCount: 0 }),
    },
  },
  data() {
    return {
      selectedRows: [],
    };
  },
  methods: {
    onSelectionChange(rows) {
      this.selectedRows = Array.isArray(rows) ? rows : [];
      this.$emit("selection-change", this.selectedRows);
    },
    onBatchDelete() {
      this.$emit("batch-delete", this.selectedRows);
    },
    canEdit(status) {
      // 只有草稿和已退回状态才能编辑
      return status === "DRAFT" || status === "REJECTED";
    },
    formatDate(v) {
      if (!v) return "";
      try {
        return dayjs(v).format("YYYY/MM/DD");
      } catch (e) {
        return v;
      }
    },
    mapStatus(s) {
      const map = {
        DRAFT: "草稿",
        PENDING: "待审核",
        REVIEWED: "已审核",
        REJECTED: "已退回",
      };
      return map[s] || s || "";
    },
  },
};
</script>

<style scoped lang="less">
.pagination-wrapper {
  display: flex;
  justify-content: center;
  padding: 12px 0;
}
</style>
